const ENDPOINTS = {
		
	GET_DESCARGA: () => 
		'/api/v1/descarga'
};

export default ENDPOINTS;